import React from 'react';

// NOT the same as the pageContext gatsby-node passes in, just same name
const PageContext = React.createContext({
    part      : 1,
    lang      : 'en',
    gw2Url    : 'https://www.guildwars2.com',
    openModal : Function,
});

export default PageContext;
